<template>
  <div class="msg">
    <v-select
      id="category"
      v-model="category_id"
      :items="categories"
      :label="getI18n('params.category')"
    ></v-select>
    <v-select
      id="match"
      :no-data-text="getI18n('errors.write_3_characters')"
      v-model="match_id"
      :label="getI18n('params.match_name')"
      :items="matches"
      autocomplete
      :disabled="category_id == null"
      :search-input.sync="search"
    ></v-select>
    <v-select
      id="team"
      v-model="team_id"
      :items="teams"
      :label="getI18n('params.team')"
      :disabled="match_id == null"
    ></v-select>
  </div>
</template>

<script>
import store from "@/store";
import i18n from "@/i18n";
import { Api } from "@/core/api.js";
const api = new Api();

export default {
  props: { params: Object },
  components: {},
  data() {
    return {
      event_id: this.params.event_id,
      player: this.params.player,
      team: this.params.team,
      category_id: null,
      match_id: null,
      match: null,
      team_id: null,
      teams: [],
      select: null,
      search: null,
      categories_list: ['U12 - B', 'U12 - A', 'U13', 'U14', 'U15', 'U16', 'U18', 'U19']
    };
  },
  computed: {
    categories: function() {
        let data = store.getters['events/getCategoriesEventSelected']()
        let categories = []
        let pos = this.categories_list.indexOf(this.team.category.max_age)
        let categoriesAvailable = this.categories_list//.slice(pos+1)
        data.forEach(category => {
            if(categoriesAvailable.includes(category.name)){
                categories.push({
                    value: category.id,
                    text: category.name
                })
            }
        })
        return categories
    },
    matches: function() {
        let data = store.getters['competition/matchs/getListNoFiltered']()
        let matches = []
        data.forEach(match => {
            matches.push({
                value: match.id,
                text: match.info.name
            })
        })
        return matches
    },
  },
  methods: {
    getI18n(label) {
      return i18n.t(label);
    },

    formatEventName(name, edition) {
      return name + "'" + edition.substring(2);
    },

    formatParam(param) {
      switch (param.type) {
        case "string":
          return param.value;
        case "role":
          return param.value.name;
        case "email":
          return param.value;
        case "phone":
          return "<v-icon size='18px'>phone</v-icon>" + param.value;
      }
    },

    loadMatches(name) {
        store.dispatch('competition/matchs/load_by_name', {name: name,category_id: this.category_id, event_id: this.event_id})
    }
  },
  created() {
    var self = this;
  },
  watch: {
    category_id: {
      handler(v) {
        // this.loadMatches()
      },
      deep: true
    },
    match_id: {
      handler(v) {
        var self = this
        let matches = store.getters['competition/matchs/getListNoFiltered']()
        let match = matches.find(match => match.id == v)
        this.match = match
        store.dispatch('teams/load_by_id', {id: match.info.local_team_id}).then(local_team =>{
            store.dispatch('teams/load_by_id', {id: match.info.away_team_id}).then(away_team =>{
                self.teams = [{value:local_team.id,text:local_team.name}, {value:away_team.id,text:away_team.name}]
            })
        })
      },
      deep: true
    },
    search (val) {
        val && val !== this.select && this.loadMatches(val)
    },
    week_id: {
      handler(v) {
        this.params.week_id = v;
      },
      deep: true
    },
    contact_type_id: {
      handler(v) {
        this.params.contact_type_id = v;
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar {
  width: 100%;
  height: 150px;
  text-align: center;

  img {
    height: 100%;
    width: auto;
  }
}

.item {
  text-align: center;
  margin: 10px auto;
  width: fit-content;

  &.strong .value {
    font-weight: bold;
    font-size: 22px;
  }

  &.role {
    border-radius: 15px;
    padding: 5px 15px;
    font-weight: lighter;
    margin: 0 auto;

    &.r5 {
      background-color: $bg-role-5;
      color: $co-role-5;
    }

    & .value {
      font-size: 18px;
      text-transform: uppercase;
    }
  }

  &.club {
    position: relative;
  }
}
</style>
